import { Pipe, PipeTransform } from '@angular/core';
import { Environment } from 'src/app/env';

@Pipe({
  name: 'imageResource'
})
export class ImageResourcePipe implements PipeTransform {

  transform(value: string): string {
    return Environment.BASE + '/files/image?name=' + value;
  }

}
